import Vue from "vue";

const dialogEvents = new Vue();

export default dialogEvents;

/*
Registered listener for openDictionary() in DictionaryWindow.vue, emitter in PrescriptionEditForm.vue
*/
